module.exports = __webpack_public_path__ + "static/media/aws_logo.a27fddf0.png";